import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EgonTown } from '../models/egon-town';

@Injectable()
export class DomicileService {
  localities$ = new BehaviorSubject<Array<EgonTown>>([]);
  location$ = new BehaviorSubject<string>('')
  zipCode$ = new BehaviorSubject<string>('')

  constructor() {
  }

}
